export const commonInfo = {
  id: '',
  code: '',
  number: '',
  name: '',
  contract_status_id: '',
  customer_id: '',
  performer_id: '',
  fact_performer_id: '',
  sign_date: '',
  start_date: '',
  end_date: '',
  contract_job_types: [],
  is_original_exists: false,
  mandatory_file_types: null,
  with_vat: true,
  manager_id: '',
  field_manager_id: '',
  accept_condition_to: 10,
  accept_condition_to_is_kalendar: true,
  special_condition_to: 0,
  special_condition_to_is_calendar: true,
  accept_condition_act: 10,
  accept_condition_act_is_kalendar: true,
  special_condition_finalizing: 0,
  special_condition_finalizing_is_calendar: true,
  sign_condition_act: 10,
  sign_condition_act_is_kalendar: true,
  special_condition_sign: 0,
  special_condition_sign_is_calendar: true,
  contract_type: 'solid',
  prepaid: false,
  prepaid_scenario: 1,
  prepaid_stages: [],
  prepaid_date_type: 1,
  prepaid_percentage: 0,
  prepaid_amount: 0,
  prepaid_condition: 0,
  prepaid_condition_is_calendar: true,
  prepaid_condition_date: null,
  payment_tasks: [],
  retention: false,
  retention_scenario: 1,
  retention_stages: [],
  retention_date_type: 1,
  retention_percentage: 0,
  retention_amount: 0,
  retention_condition: 0,
  retention_condition_is_calendar: true,
  retention_condition_date: null
}
export const subInfo = {
  contract_object_types: [],
  work_region: '',
  federal_district_id: '',
  profile_work_region_id: '',
  contract_climate_conditions: [],
  contract_project_stages: [],
  contract_responsibility_levels: [],
  special_tech_conditions: false,
  contract_territory_types: [],
  contract_offshore_drillings: [],
  description: ''
}

export const roadMap = {
  roadmaps: []
}
export const documents = {
  object_resources: []
}

export const subInfoRows = [
  {
    type: 'select',
    selectType: 'multi',
    title: 'Тип объекта',
    value: 'object_types',
    prop: 'contract_object_types',
    propName: 'object_type_names',
    idName: 'object_type_id'
  },
  {
    type: 'select',
    selectType: 'single',
    title: 'Тип тендера',
    value: 'tender_type',
    prop: 'tender_type_id',
    propName: 'tender_type_name'
  },
  {
    type: 'textarea',
    title: 'Ссылка на закупку',
    value: 'tender_link',
    prop: 'tender_link',
    propName: 'tender_link'
  },
  {
    type: 'textarea',
    title: 'Регион выполнения работ',
    value: 'work_regions',
    prop: 'work_region',
    placeholder: 'Например, Московская обл., Сергиев Посад',
    propName: 'work_region'
  },
  {
    type: 'select',
    selectType: 'single',
    title: 'Федеральный округ',
    value: 'federal_districts',
    prop: 'federal_district_id',
    propName: 'federal_district_name'
  },
  {
    type: 'select',
    selectType: 'single',
    title: 'Регион выполнения работ (профильный)',
    value: 'profile_work_regions',
    prop: 'profile_work_region_id',
    propName: 'profile_work_region_name'
  },
  {
    type: 'select',
    selectType: 'multi',
    title: 'Вид территории',
    value: 'territory_types',
    prop: 'contract_territory_types',
    propName: 'territory_type_names',
    idName: 'territory_type_id'
  },
  {
    type: 'select',
    selectType: 'multi',
    title: 'Вид бурения на акватории',
    value: 'offshore_drillings',
    prop: 'contract_offshore_drillings',
    propName: 'offshore_drilling_names',
    idName: 'offshore_drilling_id'
  },
  {
    type: 'select',
    selectType: 'multi',
    title: 'Климатические условия',
    value: 'climate_conditions',
    prop: 'contract_climate_conditions',
    propName: 'climate_conditions_names',
    idName: 'climate_condition_id'
  },
  {
    type: 'select',
    selectType: 'single',
    title: 'Тип проектировщика',
    value: 'planer_types',
    prop: 'planer_type_id',
    propName: 'planer_type'
  },
  {
    type: 'select',
    selectType: 'multi',
    title: 'Стадия проектирования',
    value: 'project_stages',
    prop: 'contract_project_stages',
    propName: 'project_stage_names',
    idName: 'project_stage_id'
  },
  {
    type: 'select',
    selectType: 'multi',
    title: 'Уровень ответственности',
    value: 'responsibility_levels',
    prop: 'contract_responsibility_levels',
    propName: 'responsibility_level_names',
    idName: 'responsibility_level_id'
  },
  {
    type: 'boolean',
    title: 'СТУ',
    value: 'special_tech_conditions',
    prop: 'special_tech_conditions',
    propName: 'special_tech_conditions'
  },
  {
    type: 'textarea',
    title: 'Описание работ',
    value: 'description',
    prop: 'description',
    propName: 'description'
  }
]

export const subInfoComplexFields = [
  ...subInfoRows
    .filter(r => r.selectType === 'multi')
    .map(({ prop, idName }) => [prop, idName])
]

export const allComplexFields = [
  ['contract_job_types', 'job_type_id'],
  ['mandatory_file_types', 'file_type_id'],
  ...subInfoComplexFields
]

export const requiredCommonFields = [
  'code',
  'number',
  'name',
  'sign_date',
  'customer_id',
  'performer_id',
  'contract_status_id'
]

export const contractTypes = [
  {
    value: 'solid',
    name: 'Твердая цена'
  },
  {
    value: 'final',
    name: 'Исполнительная смета'
  }
]

export const conditions = [
  {
    id: 0,
    conditionProp: 'accept_condition_to',
    conditionLabel: 'Срок согласования ТО (в дн.)',
    isCalendarProp: 'accept_condition_to_is_kalendar',
    specialProp: 'special_condition_to',
    specialLabel: 'Особые условия согласования ТО',
    isSpecialCalendarProp: 'special_condition_to_is_calendar'
  },
  {
    id: 1,
    conditionProp: 'accept_condition_act',
    conditionLabel: 'Срок подписания актов (в дн.)',
    isCalendarProp: 'accept_condition_act_is_kalendar',
    specialProp: 'special_condition_finalizing',
    specialLabel: 'Особые условия подписания актов',
    isSpecialCalendarProp: 'special_condition_finalizing_is_calendar'
  },
  {
    id: 2,
    conditionProp: 'sign_condition_act',
    conditionLabel: 'Срок оплаты (в дн.)',
    isCalendarProp: 'sign_condition_act_is_kalendar',
    specialProp: 'special_condition_sign',
    specialLabel: 'Особые условия оплаты',
    isSpecialCalendarProp: 'special_condition_sign_is_calendar'
  }
]

export const steps = [
  {
    index: 0,
    title: 'Общие сведения',
    content: 'Заполнение основной информации',
    icon: 'md-information-circle',
    component: 'common-info'
  },
  {
    index: 1,
    title: 'Условия приемки и оплаты работ',
    content:
      'Указание типа налогообложения, сроков приемки ТО, подписания актов и т.д.',
    icon: 'md-cash',
    component: 'pay-conditions'
  },
  {
    index: 2,
    title: 'Дополнительные сведения',
    content:
      'Заполнение дополнительной информации (регион выполнения работ, уровень ответственности и др.',
    icon: 'md-information-circle',
    component: 'sub-info'
  },
  {
    index: 3,
    title: 'Календарный план',
    content: 'Заполнение информации по этапам работ',
    icon: 'md-calendar',
    component: 'roadmap'
  },
  {
    index: 4,
    title: 'Аванс',
    content: 'Указание условия получения аванса',
    icon: 'md-construct',
    component: 'prepaid'
  },
  {
    index: 5,
    title: 'Гарантийное удержание',
    content: 'Указание условий получения гарантийного удержания',
    icon: 'md-construct',
    component: 'retention'
  },
  {
    index: 6,
    title: 'Документы',
    content: 'Прикрепление всех основных документов',
    icon: 'md-document',
    component: 'documents'
  }
]

export const archiveSteps = [
  {
    index: 0,
    title: 'Общие сведения',
    content: 'Заполнение основной информации',
    icon: 'md-information-circle',
    component: 'common-info'
  },
  {
    index: 1,
    title: 'Дополнительные сведения',
    content:
      'Заполнение дополнительной информации (регион выполнения работ, уровень ответственности и др.',
    icon: 'md-information-circle',
    component: 'sub-info'
  },
  {
    index: 2,
    title: 'Календарный план',
    content: 'Заполнение информации по этапам работ',
    icon: 'md-calendar',
    component: 'roadmap'
  },
  {
    index: 3,
    title: 'Документы',
    content: 'Прикрепление всех основных документов',
    icon: 'md-document',
    component: 'documents'
  }
]

export const prepaidFieldsToDelete = [
  'prepaid_amount',
  'prepaid_condition',
  'prepaid_condition_is_calendar',
  'prepaid_condition_date'
]
export const retentionFieldsToDelete = [
  'retention_amount',
  'retention_condition',
  'retention_condition_is_calendar',
  'retention_condition_date'
]

export const creatingModes = [
  // {
  //   id: 'no-documents',
  //   name: 'Стадия переговоров'
  // },
  // {
  //   id: 'guarantee-letter',
  //   name: 'Гарантийное письмо'
  // },
  {
    id: 'normal',
    name: 'Договор в наличии'
  },
  {
    id: 'archive',
    name: 'Архивный договор'
  }
]
